const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimulcasticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-225,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard2",
    transform: "matrix(0.177143,0,0,0.525424,185.143,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 0,
    width: 175,
    height: 59,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.34275,1.1356,-3.12308,1.84613,-417.845,-244.283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166,34C166.816,40.689 171.037,48.037 176.392,52.092C170.221,49.457 161.779,49.457 155.608,52.092C160.963,48.037 165.184,40.689 166,34Z",
    style: {
      fill: "none",
      stroke: "rgb(219,189,190)",
      strokeWidth: "2.19px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulcasticon);
export default __webpack_public_path__ + "static/media/simulcasticon.4d3b631f0f0f3efd89afce9467d6d94d.svg";
export { ForwardRef as ReactComponent };